import React from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';

import { CerbosPermissionStatus, PermissionStore } from '../../stores/permission-store';
import { FeatureFlagsManager } from '../../utils/core/feature-flags-manager';
import { AccessTokens } from '../components/access-tokens/access-tokens';
import { PageContainer } from '../components/page-container';
import { useOptionalUserState } from '../state/user-state/user-state';

const AccessTokensRoute = () => {
  const { t } = useTranslation();
  const userState = useOptionalUserState();
  const isOrganizationAdmin = userState?.isOrganizationAdmin ?? false;
  const cerbosAccessCheck = PermissionStore.instance.checkAccessToView('view:system_session_links');

  // Check if user is organization admin
  if (!isOrganizationAdmin) {
    return <Navigate replace={true} to="/projects" />;
  }

  // Check Cerbos view permission if feature flag is enabled
  if (
    FeatureFlagsManager.instance.isEnabled('SK-4477-access-management') &&
    cerbosAccessCheck !== CerbosPermissionStatus.NOT_DEFINED &&
    cerbosAccessCheck !== CerbosPermissionStatus.ACCEPT
  ) {
    return <Navigate replace={true} to="/projects" />;
  }

  return (
    <PageContainer title={t('menu.accessTokens.title', { ns: 'navigation' })}>
      <AccessTokens />
    </PageContainer>
  );
};

export { AccessTokensRoute };
